// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3CPWH","content":"GlobalSearch_content__1xYMM"};